import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PasBonProduitStep from './PasBonProduitStep';

import dateHelper from 'utils/dateHelper';
import localStorageHelper from 'utils/localStorageHelper';
import { estPieceRapido } from 'utils/depotHelper';

class PasBonProduitStepContainer extends React.Component {
    

    render() {
        return (
            <PasBonProduitStep {...this.props} />
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    let rapido = false;
    let livraisonDirecte = false;
    let adresse = null;
    let dateLivraison = null;

    let piece = state.pieceGestion[ownProps.namespace].piecesGestion ?
        state.pieceGestion[ownProps.namespace].piecesGestion.items.find(p => p.numeroPiece === ownProps.reclamation.numeroPiece)
        : null;
    let agePiece = 0;

    let poidsTheorique = '';
    let transporteurInitial = null;

    let colisLogistiques = [];

    // RECLA-771 le contact pour un enlèvement, nom = contact réclamation,  mail et téléphone = ceux du client
    let donneurOrdre = {
        nom: ownProps.reclamation.suiviNomContact,
        mail: ownProps.reclamation.suiviEmail !== null && ownProps.reclamation.suiviEmail !== '' ? ownProps.reclamation.suiviEmail : ownProps.reclamation.client.email,
        telephoneMobile: ownProps.reclamation.suiviTelephoneMobile !== null && ownProps.reclamation.suiviTelephoneMobile !== '' ? ownProps.reclamation.suiviTelephoneMobile : ownProps.reclamation.client.telephoneMobile
    };

    if (piece) {
        rapido = estPieceRapido(piece);
        livraisonDirecte = piece.modeLivraison === 'LD';
        adresse = piece.adresseLivraison;
        dateLivraison = piece.dateLivraison;
        agePiece = dateHelper.age(piece.dateLivraison);
        poidsTheorique = ownProps.reclamation.lignes.reduce((accumulator, currentValue) => accumulator + currentValue.poids * currentValue.quantiteAnomalie, 0);

        transporteurInitial = {
            nom: piece.transporteur,
            contrat: piece.contrat
        },

            colisLogistiques = state.colisLogistique.colisLogistiques.items;
    }

    let isUtilisateurMagasin = localStorageHelper.getUtilisateurMagasin();

    let exclusionControleAgePiece = localStorageHelper.getUtilisateurExclusionControleAgePiece();

    return {
        rapido: rapido,
        livraisonDirecte: livraisonDirecte,
        adresse: adresse,
        donneurOrdre: donneurOrdre,
        poidsTheorique: poidsTheorique,
        dateLivraison: dateLivraison,
        agePiece: agePiece,
        transporteurInitial: transporteurInitial,
        colisLogistiques: colisLogistiques,
        isUtilisateurMagasin: isUtilisateurMagasin,
        exclusionControleAgePiece: exclusionControleAgePiece
    };
};

//const mapDispatchToProps = (dispatch) => ({
//});

PasBonProduitStepContainer.propTypes = {
    reclamation: PropTypes.object.isRequired,
    namespace: PropTypes.string.isRequired
};

export default connect(mapStateToProps, null)(React.memo(PasBonProduitStepContainer));